<script setup lang="ts">
const props = defineProps<{
  slides: number
  loop?: boolean
  navigation?: boolean
  showBullet?: boolean
  navigationColor?: string | null
  nextSlide?: () => void
  prevSlide?: () => void
}>()

const SWIPER_NAV_CLASSES: { [key: string]: string } = {
  default: 'swiper-nav-light swiper-nav-bg-yellow',
  yellow: 'swiper-nav-dark swiper-nav-bg-yellow',
  white: 'swiper-nav-dark swiper-nav-bg-white',
  black: 'swiper-nav-light swiper-nav-bg-black',
}

const swiperClasses = computed(
  () => SWIPER_NAV_CLASSES[props.navigationColor ? props.navigationColor : 'default']
)
</script>
<template>
  <Swiper
    :modules="[SwiperEffectCreative, SwiperPagination, SwiperNavigation]"
    :slides-per-view="slides"
    :loop="loop"
    :short-swipes="true"
    :pagination="
      showBullet && {
        type: 'bullets',
        clickable: true,
      }
    "
    :class="swiperClasses"
    :navigation="navigation"
    @navigation-next="nextSlide"
    @navigation-prev="prevSlide"
  >
    <slot />
  </Swiper>
</template>

<style>
.swiper-nav-dark {
  --swiper-navigation-color: #000000;
  --swiper-pagination-color: #ffbc0d;
}

.swiper-nav-light {
  --swiper-navigation-color: #ffffff;
  --swiper-pagination-color: #ffbc0d;
}

.swiper-nav-bg-yellow .swiper-button-next,
.swiper-nav-bg-yellow .swiper-button-prev {
  background-color: #ffbc0d;
}

.swiper-nav-bg-white .swiper-button-next,
.swiper-nav-bg-white .swiper-button-prev {
  background-color: #ffffff;
}

.swiper-nav-bg-black .swiper-button-next,
.swiper-nav-bg-black .swiper-button-prev {
  background-color: #000000;
}

.swiper-button-prev {
  z-index: 0;
  @apply left-0 top-[40%];
}

.swiper-button-next {
  z-index: 0;
  @apply right-0 top-[40%];
}

.swiper-button-next,
.swiper-button-prev {
  @apply rounded-full border-2;
}

@media screen and (min-width: 768px) {
  .swiper-button-next,
  .swiper-button-prev {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }

  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 0.875rem !important;
  }
}

@media screen and (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }

  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 1.25rem !important;
  }
}
</style>
